import type { ISiteTagsDto } from "app/pages/sales-intelligence/domain/leads/types/filter-values";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { FilterValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";
import { calculateArrayDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/calculateValueDeltaUtils";

import { SiteTagsFilterValue } from "./SiteTagsFilterValue";

class SiteTagsFilterModel extends FilterPanelBaseFilter<ISiteTagsDto, undefined, ISiteTagsDto | undefined> {
    toApiValue(value?: ISiteTagsDto): ISiteTagsDto | undefined {
        if (!value || new SiteTagsFilterValue(value).isEmpty()) {
            return undefined;
        }

        return value;
    }

    isValueEmpty(value?: ISiteTagsDto): boolean {
        return new SiteTagsFilterValue(value).isEmpty();
    }

    calculateValueDelta(previousValue?: ISiteTagsDto, newValue?: ISiteTagsDto): FilterValueDelta<string> {
        return calculateArrayDelta(previousValue?.values, newValue?.values);
    }
}

export default SiteTagsFilterModel;
